
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hd-photo-converter",
      function () {
        return require("private-next-pages/hd-photo-converter/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hd-photo-converter"])
      });
    }
  